<section class="w-10/12 sm:w-9/12 mx-auto pt-16 pb-12">
  <h2 class="lg:text-center pb-2">{{ "main_page.dual_pillar.title" | translate }}</h2>
  <p class="lg:text-center max-w-3xl mx-auto pb-8">
    {{ "main_page.dual_pillar.subtitle" | translate }}
  </p>

  <div class="flex flex-wrap lg:flex-nowrap gap-8 items-stretch">
    <!-- SaaS Platform column -->
    <div class="w-full lg:w-7/12">
      <div class="pygSaasColumn h-full flex flex-col">
        <div class="pygPillarHeader mb-5">
          <h4>{{ "main_page.dual_pillar.saas_title" | translate }}</h4>
          <p class="pt-1">{{ "main_page.dual_pillar.saas_subtitle" | translate }}</p>
        </div>

        <div class="flex flex-col gap-3 flex-1">
          @for (product of products; track product.nameKey) {
            <a langRouterLink="solutions" class="pygProductCard p-5 flex items-start gap-4">
              <div class="pygProductIcon shrink-0">
                <ng-icon [name]="product.ngIcon" style="font-size: 1.25rem"></ng-icon>
              </div>
              <div>
                <h6 class="pb-1">{{ product.nameKey | translate }}</h6>
                <p class="pygCardText">{{ product.descKey | translate }}</p>
              </div>
            </a>
          }
        </div>
      </div>
    </div>

    <!-- Innovation column -->
    <div class="w-full lg:w-5/12">
      <div class="pygInnovationCard p-8 h-full flex flex-col justify-between">
        <div>
          <h4 class="pygInnoTitle">{{ "main_page.dual_pillar.iaas_title" | translate }}</h4>
          <p class="pygInnoText pt-3 pb-6">
            {{ "main_page.dual_pillar.iaas_subtitle" | translate }}
          </p>
        </div>

        <div class="flex flex-col gap-4 mb-6">
          @for (svc of iaasServices; track svc.nameKey) {
            <div class="pygInnoService flex items-start gap-3">
              <div class="pygInnoServiceIconWrap shrink-0">
                <ng-icon [name]="svc.icon" class="pygInnoServiceIcon"></ng-icon>
              </div>
              <div>
                <h6 class="pygInnoServiceName">{{ svc.nameKey | translate }}</h6>
                <p class="pygInnoServiceDesc">{{ svc.descKey | translate }}</p>
              </div>
            </div>
          }
        </div>

        <a langRouterLink="innovation" class="pygInnoLink">
          {{ "main_page.dual_pillar.iaas_cta" | translate }}
          <img src="assets/img/Shared/arrow-right.svg" alt="" class="inline-block ml-2 w-4" />
        </a>
      </div>
    </div>
  </div>
</section>
